import * as $ from "jquery";
import * as site from "site";

export type CartItemJSON = GPCartItemJSON | AvdbCartItemJSON | AvdbBundleCartItemJSON | EnablementCartItemJSON | PromoCodeCartItemJSON;

export interface GPCartItemJSON {
	readonly itemType: "gp";
	partNumber: string;
	subscriptionID: string;
	deviceIDs: Array<string>;
	autoRenew: boolean;
	existingSubscriptionUuid?: string;
	futureStartDate?: Date;
}

export interface AvdbCartItemJSON {
	readonly itemType: "avdb";
	partNumber: string;
	deviceID: number;
	futureStartDate?: Date;
}

export interface AvdbBundleCartItemJSON {
	readonly itemType: "avdbBundle";
	partNumber: string;
	aircraftID: string;
	deviceID: number;
	futureStartDate?: Date;
}

export interface EnablementCartItemJSON {
	readonly itemType: "enablement";
	partNumber: string;
	deviceID: number;
}

export interface PromoCodeCartItemJSON {
	readonly itemType: "promoCode";
	partNumber: string;
	code: string;
}

export function cartItemsEquivalent(a: CartItemJSON, b: CartItemJSON) {
	if (a.itemType !== b.itemType || a.partNumber !== b.partNumber)
		return false;

	switch (a.itemType) {
		case "gp":
			b = b as GPCartItemJSON;
			return a.subscriptionID === b.subscriptionID;

		case "avdb":
			b = b as AvdbCartItemJSON;
			return a.deviceID === b.deviceID;

		case "avdbBundle":
			b = b as AvdbBundleCartItemJSON;
			return a.deviceID === b.deviceID && a.aircraftID === b.aircraftID;

		case "enablement":
			b = b as EnablementCartItemJSON;
			return a.deviceID === b.deviceID;

		case "promoCode":
			b = b as PromoCodeCartItemJSON;
			return a.code === b.code;

		default:
			return false;
	}
}

export function addOrUpdateCartItem(newCartItem: CartItemJSON) {
	$.ajax({
		type: 'POST',
		url: `${site.contextPath}/api/carts/current/products`,
		dataType: 'json',
		data: newCartItem
	});
}

export function clearCart() {
	$.ajax({
		type: 'GET',
		url: `${site.contextPath}/api/carts/current/complete`,
		dataType: 'json'
	});
}
